import styled from "styled-components";

const CollapseContainer = styled.div`
  max-width: 250px;
`;

export default CollapseContainer;
